module.exports = __webpack_public_path__ + "static/media/icons_Bilan découverte - membres supérieurs.130d8574.svg";